import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';

import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { useMouseContent } from 'src/utils/mouse/mouseContent';

import { Content_TQC1020_R01 } from './Content_TQC1020_R01';
import { DetailTable_TQC1020_R01 } from './DetailTable_TQC1020_R01';
import { TQC1020_R01HeaderDto, TQC1020_R01DetailDto } from './Dto_TQC1020_R01';
import { SearchSection_TQC1020_R01 } from './SearchSection_TQC1020_R01';
import { Table_TQC1020_R01 } from './Table_TQC1020_R01';

export const Container_TQC1020_R01 = () => {
    useFetchActionbarAuth('TQC1020_R01');

    const gridRef = useRef<AgGridReact<TQC1020_R01HeaderDto>>(null);
    const detailGridRef = useRef<AgGridReact<TQC1020_R01DetailDto>>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const isResizing = useRef(false);

    const { splitValue, handleMouseDown } = useMouseContent({
        resizer: {
            code: 'TQC1020_R01',
            type: 'height',
            storageKey: 'TQC1020_R01-split-height',
            min: 20,
            max: 80,
            default: 55,
        },
        isResizing,
        containerRef,
    });

    const {
		clickable, setClickable,
		defaultTQC1020_R01DetailRow,
		handleInsertClick,
		fetchData,
		handleExcelClick,
		saveResultList,
		initData,
	} = Content_TQC1020_R01({
        gridRef,
        detailGridRef,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onCreateClick={() => {}}
                onDeleteClick={() => {}}
                onSaveClick={saveResultList}
                onExcelClick={handleExcelClick}
                onInitClick={initData}
            />
            <SearchSection_TQC1020_R01 onEnterKeyDown={fetchData} />

            <div className="flex flex-col flex-1 p-[12px] gap-[4px] min-h-0" ref={containerRef}>
                <div style={{ height: `${splitValue}%` }}>
                    <Table_TQC1020_R01 gridRef={gridRef} />
                </div>

                <div
                    className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300 flex-shrink-0"
                    onMouseDown={(e) => handleMouseDown('UD', e.nativeEvent)}
                    onDragStart={(e) => e.preventDefault()}
                />

                <div style={{ height: `${100 - splitValue}%` }}>
                    <DetailTable_TQC1020_R01
						detailGridRef={detailGridRef}
						defaultTQC1020_R01DetailRow={defaultTQC1020_R01DetailRow()}
						clickable={clickable}
						setClickable={setClickable}
						handleInsertClick={handleInsertClick}
					/>
                </div>
            </div>

            <Message />
        </div>
    );
};
